import { useState } from "react";

// react-router-dom components
// import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
// import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React example components
import DefaultNavbar from "components/Navbars/DefaultNavbar";

// Material Kit 2 React page layout routes
import routes from "routes";
import { useError } from "hooks/ErrorContext";
import { useSuccess } from "hooks/SuccessContext";
// Images
import bgImage from "assets/images/school.jpg";
import { useNavigate } from "react-router-dom";

import {
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  // Alert,
} from "@mui/material";
import { auth } from "utils/firebase";
import { createUserWithEmailAndPassword, sendEmailVerification, deleteUser } from "firebase/auth";
import UserApi from "apis/UserApi";
import { useTheme } from '@mui/material/styles';
import { useAuth } from "hooks/AuthContext";
import useUploadImage from "hooks/imageContext";

function SignUpBasic() {
  const base_URL = process.env.REACT_APP_API_BASE_URL;

  const { showError } = useError();
  const { showMessage } = useSuccess();
  const navigate = useNavigate();
  const theme = useTheme();
  const [userId, setUserId] = useState()
  const [media, setMedia] = useState()
  const { uploadImage, loading: uploading, data: imageData } = useUploadImage();
  const [imgLoader, setImgLoader] = useState(false)
  const [formData, setFormData] = useState({
    profile_image: "",
    name: "",
    password: "",
    email: "",
    mobile_num: "",
    school_num: null,
    grad_year: null,
    address: "",
    occupation: "",
    speciality: "",
    private_info: false,
    uid: "",
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (files) {
      try {
        setImgLoader(true)
        const data = await uploadImage(files, "ProfileImage");
        console.log(data);
        setMedia(data?.data?.[0]);
        // setFormData((prev) => ({ ...prev, media_url: [...data?.data, ...uploadedImages] }));
      } catch (err) {
        console.log(err);
        showError("Failed to upload media");
      }
       setImgLoader(false)
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      await sendEmailVerification(userCredential.user);
      const { uid } = userCredential.user;
      const signUpData = {
        ...formData,
        user_id: uid,
        profile_image: media,
        school_num: String(formData.school_num),
        grad_year: Number(formData.grad_year),
      };
      setUserId(uid)
      console.log(signUpData);

      const data = await UserApi.signUpUsers(signUpData);

      console.log(data);

      showMessage("Form submitted successfully! Email verification link was sent to your provided Email. Please verify your email by clicking on the link in the email.");
      navigate("/pages/authentication/sign-in");

    } catch (error) {
      if (error?.message == "Firebase: Error (auth/email-already-in-use).") {
        showError("Email already registered.Try login instead");
      } else {
      showError(error?.message)

      }
      console.log()
      // deleteUser(auth.currentUser)
    }
  };

  return (
    <>
      <MKBox
  position="absolute"
  top={0}
  left={0}
  zIndex={1}
  width="100%"
  minHeight="100vh"
  sx={{
    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
      `${linearGradient(
        rgba(gradients.dark.main, 0.6),
        rgba(gradients.dark.state, 0.6)
      )}, url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
/>
<MKBox px={2} width="100%" height="100vh" mx="auto" position="relative" zIndex={2} style={{ color: theme.palette.info }}>
  <Grid container spacing={2} justifyContent="center" alignItems="center" height="100%">
    <Grid item xs={11} sm={9} md={6} lg={7} xl={7}>
      <Card width="100%" sx={{backgroundColor:"#fff"}}>
        <MKBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={3}
          mb={2}
          textAlign="center"
        >
          <MKTypography variant="h4" fontWeight="bold" color="white" mt={1} sx={{textAlign:'left'}}>
                  Please register your details<br/>
                  <span style={{fontSize:13}}>*Details registered will be verified by your class representative and admin</span>
          </MKTypography>
        </MKBox>
        <FormControl
          fullWidth
          component="form"
          onSubmit={handleSubmit}
                sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            width: "100%",
            margin: "0 auto",
            mt: 5,
            pt: 2,
            pb: 3,
            px: 3,
          }}
        >

                <div className="flex items-center gap-4">

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    className="hidden"
                    id="image-upload"
                  />
                  <label
                    htmlFor="image-upload"
                    className="px-4 py-2 bg-blue-50 text-blue-600 rounded-lg cursor-pointer hover:bg-blue-100 transition-colors duration-200"
                  >
                    <i className="fas fa-upload mr-2"></i>
                    Choose profile picture
                  </label>
                  <div className="flex items-center gap-2">
                    {imgLoader && <span>Loading...</span>}
                    {media && <img

                            src={`${base_URL}/get-image?objectKey=${media}`}

                            className="h-20 w-20 object-cover rounded-lg"
                          />}
                    </div>
                </div>
          {/* Row 1: Name, Email, Password */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                name="name"
                label="Name"
                fullWidth
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="email"
                type="email"
                label="Email"
                fullWidth
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="password"
                type="password"
                label="Password"
                fullWidth
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Grid>
          </Grid>

          {/* Row 2: Mobile Number, School Number, Year of Graduation */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                name="mobile_num"
                label="Mobile Number"
                fullWidth
                value={formData.mobile_num}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="school_num"
                label="School Number Eg. 123/N"
                fullWidth
                value={formData.school_num}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="grad_year"
                label="Year of Graduation / Passout batch"
                fullWidth
                type="number"
                value={formData.grad_year}
                onChange={handleChange}
                required
                inputProps={{ min: 1950, max: new Date().getFullYear() }}
              />
            </Grid>
          </Grid>

          {/* Row 3: Address */}
          <TextField
            name="address"
            label="Address"
            fullWidth
            multiline
            value={formData.address}
            onChange={handleChange}
          />

          {/* Row 4: Occupation and Specialty */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="Occupation-label">Occupation</InputLabel>
                <Select
                  name="occupation"
                  label="Occupation"
                  labelId="Occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  required
                  sx={{ minWidth: 120, height: 45 }}
                >
                  {["Air Force", "Army", "Navy", "Doctor", "Engineer", "Businessman", "Other"].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="speciality"
                label="Specialty"
                fullWidth
                value={formData.speciality}
                onChange={handleChange}
              />
            </Grid>
          </Grid>

          {/* Row 5: Share Information Privately */}
          <FormControlLabel
            control={
              <Checkbox
                name="private_info"
                checked={formData.private_info}
                onChange={handleChange}
              />
            }
            label="Share Information Privately"
          />

          {/* Submit Button */}
          <MKBox mt={4} mb={1}>
            <MKButton type="submit" variant="contained" color="info" fullWidth>
              Submit
            </MKButton>
          </MKBox>
        </FormControl>
      </Card>
    </Grid>
  </Grid>
</MKBox>

    </>
  );
}

export default SignUpBasic;
